import { Link } from "react-router-dom";
import Seo from "./Seo";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";
import ChatWidget from "./ChatWidget";

export default function PageLayout({ seo, children }) {
  return (
    <div className="grain relative">
      <Seo {...seo} />
      <Navbar ready />
      <main className="bg-ivory">{children}</main>
      <Footer />
      <WhatsAppFloat />
      <ChatWidget />
      <div className="fixed inset-x-0 bottom-0 z-40 lg:hidden" data-testid="mobile-cta-bar">
        <Link
          to="/contact/"
          data-testid="mobile-cta-enquire"
          className="flex items-center justify-center bg-gold py-4 text-xs font-semibold uppercase tracking-[0.22em] text-navy"
        >
          Enquire About Your Island Stay
        </Link>
      </div>
    </div>
  );
}
